/*
 * <stock-shortfall stock="5"> — shows a warning when the quantity the shopper has
 * chosen exceeds the stock on hand. Only rendered for products that are set to
 * continue selling when out of stock, so the order is still allowed to go through.
 *
 * Listens on the document rather than binding to the quantity field directly,
 * because the quantity block is re-rendered by the Section Rendering API each
 * time the shopper changes variant.
 */
class StockShortfall extends HTMLElement {
    connectedCallback() {
        this.stock = parseInt(this.getAttribute('stock'), 10);
        this.scope = this.closest('product-variant-provider') || document;

        this.handleChange = (event) => {
            const field = event.target;
            if (!field || field.name !== 'quantity') return;
            this.update();
        };

        document.addEventListener('input', this.handleChange);
        document.addEventListener('change', this.handleChange);

        this.update();
    }

    disconnectedCallback() {
        document.removeEventListener('input', this.handleChange);
        document.removeEventListener('change', this.handleChange);
    }

    get quantity() {
        const field = this.scope.querySelector('[name="quantity"]');
        if (!field) return 1;
        const value = parseInt(field.value, 10);
        return Number.isNaN(value) ? 1 : value;
    }

    update() {
        if (!Number.isFinite(this.stock)) return;

        const short = this.quantity > this.stock;
        this.hidden = !short;

        // Hide the ordinary "In stock" badge while the shortfall notice is up,
        // otherwise the two contradict each other.
        const main = this.parentElement
            ? this.parentElement.querySelector('[data-stock-alert-main]')
            : null;
        if (main) main.hidden = short;
    }
}

if (!customElements.get('stock-shortfall')) {
    customElements.define('stock-shortfall', StockShortfall);
}
